import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { AdHocSearchComponent } from './ad-hoc-search.component';
import { ToastModule } from 'primeng';

const routes: Routes = [
  { path: '', component: AdHocSearchComponent, data: { title: 'Search Criteria' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdHocSearchRoutingModule {}

@NgModule({
  imports: [
    AdHocSearchRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [AdHocSearchComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdHocSearchModule {}
